import TradingOffersList from 'modules/trading/pages/TradingOffersList';
import { TradingOfferType } from 'types/TradingOffer';
import { TradingOffersListProvider } from '../contexts/TradingOffersListContext';

const TradingOffersListContainer = () => (
  <TradingOffersListProvider>
    <TradingOffersList tradingOfferType={TradingOfferType.BUY} />
  </TradingOffersListProvider>
);

export default TradingOffersListContainer;
